import { myAxios } from "../utils/common";
import { getClientInfo } from "../utils/deviceInfo";

export interface LoginPayload {
  email: string;
  password: string;
  override?: boolean;
}

export async function loginFn(payload: LoginPayload): Promise<string> {
  // cihaz bilgisini ekle (account-sharing tespiti için)
  const response = await myAxios.post("/user/login", {
    ...payload,
    // email büyük/küçük harf ve boşluk duyarsız olsun (mobil klavye ilk harfi büyütüyor)
    email: payload.email.trim().toLowerCase(),
    clientInfo: getClientInfo(),
  });
  return response.data.token;
}


export async function refreshTokenFn(payload: { token: string }): Promise<string> {
  const response = await myAxios.post("/user/refreshToken", {
    ...payload,
    clientInfo: getClientInfo(),
  });
  return response.data.token;
}
